"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChromeColors = exports.colorize = void 0;
const colors = {
    yellow: 'color: orange;',
    clear: 'color: auto;',
    blue: 'color: blue;',
    red: 'color: red;',
    green: 'color: green;'
};
const levelColors = {
    debug: 'blue',
    info: 'green',
    warn: 'yellow',
    error: 'red'
};
function colorize(text, level = '') {
    const color = getLevelColor(level);
    if (!color)
        return text;
    return `%c${text}%c`;
}
exports.colorize = colorize;
function getChromeColors(level = '') {
    const color = getLevelColor(level);
    if (!color)
        return [];
    return [color, colors.clear];
}
exports.getChromeColors = getChromeColors;
function getLevelColor(level) {
    const color = levelColors[level.toLowerCase()];
    return color && colors[color];
}
//# sourceMappingURL=chrome-colors.js.map